<template>
  <div :class="['right-banner-container']">
    <div class="banner-item" @click="goBack" style="margin-bottom: 14px;">
      <!-- <img src="@/assets/zs_imgs/wiki-icon-back.png" alt="" /> -->
      <i class="icon zsicon icon-fanhui" alt=""></i>
    </div>
    <el-popover
      width="406"
      trigger="hover"
      placement="left-start"
      popper-class="zs-link-popover"
      v-if="gameInfo.Config"
    >
      <div class="title-content">
        <div v-if="gameInfo.Config && gameInfo.Config.slogan" class="img-container">
          <img :src="handleImgSize(gameInfo.Config.slogan)" alt="" class="slogan" />
        </div>
        <div class="game-detail">
          <div class="desc" v-html="gameInfo.description"></div>
        </div>
      </div>
      <div slot="reference" class="banner-item" style="margin-bottom: 14px;">
        <!-- <img src="@/assets/images/notice-btn-icon.png" alt="" /> -->
        <i class="icon zsicon icon-gonggao" alt=""></i>
        <span>公告</span>
      </div>
    </el-popover>
    <div class="banner-item" v-if="$hasPermission('manage')" @click="handleManage">
      <i class="icon zsicon icon-shezhi" alt=""></i>
      <span>管理</span>
    </div>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";
import friendLinks from "./friendLinks";

export default {
  name: "rightBanner",
  components: { friendLinks },
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    },
    linkInfos: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {},
  data() {
    return {
      // scrollY: 0
    };
  },
  methods: {
    handleManage() {
      this.$router.push(`/${this.gameInfo.alias}/admin`);
    },
    handleMessage() {
      const url = `${window.location.origin}/${this.gameInfo.alias}/new`;
      window.open(url, "_blank");
    },
    // winScroll() {
    //   this.scrollY = window.document.documentElement.scrollTop || window.document.body.scrollTop;
    // },
    // 返回
    goBack() {
      if (history.length > 1) {
        window.history.back();
      } else {
        this.$router.push(`/${this.alias}/`);
      }
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>
<style lang="less">
.right-banner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 72px;
  right: 50%;
  margin-right: 615px;
  width: 58px;
  /deep/.zs-link-popover {
    background: rgba(208, 239, 255, 0.08);
  }
  .banner-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    font-size: 10px;
    color: var(--zs-aside-bar-text-color);
    background: var(--zs-aside-bar-bg);
    cursor: pointer;
    border-radius: 50%;

    i {
      font-size: 24px;
    }
    span {
      font-size: 12px;
    }
  }
}
.title-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-container {
    padding: 0 20px 30px 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid #e9e9e9;
    img {
      max-width: 184px;
    }
  }
  .game-detail {
    padding: 0 20px;
    padding-bottom: 30px;
    color: var(--zs-search-pop-text-color);
  }
}
.link-box {
  .model-title {
    /deep/ .el-divider--horizontal {
      margin: 17px 0 28px 0;
    }
  }
}
.zs-link-popover {
  background: var(--zs-search-pop-bg-color);
  border-color: var(--zs-search-pop-bg-color);
  .popper__arrow {
    border-right-color: var(--zs-search-pop-bg-color) !important;
    &:after {
      border-right-color: var(--zs-search-pop-bg-color) !important;
    }
  }
}
</style>
